export const GET_SETTINGS_LIST_SUCCESS = 'GET_SETTINGS_LIST_SUCCESS';
export const getSettingsListSuccess = response => ({
  type: GET_SETTINGS_LIST_SUCCESS,
  payload: {
    response,
  },
});

export const TOGGLE_SETTING_LOADING = 'TOGGLE_SETTING_LOADING';
export const toggleSettingLoading = isLoading => ({
  type: TOGGLE_SETTING_LOADING,
  payload: { isLoading },
});
